module.exports = __webpack_public_path__ + "9df5c0f63362e6e74cee3dd8b5472279.svg";